const messages = {
  'en-US': {
    addToStudy: {
      addToStudy: 'Add',
    },
    addToStory: {
      title: 'Add to Story',
      titleLabel: 'Title',
      descriptionLabel: 'Add an Insight',
      createNewStory: 'Create a new story',
      selectExistingStory: 'Select a Story',
      newStoryTitle: 'Enter new story title',
      loading: 'Loading',
      addToStory: 'Add',
      titlePlaceholder: 'Give this insight a title',
      descriptionPlaceholder:
        'Insights help you tell others what is important or interesting about this',
      newStoryError: 'There was an error creating the story',
      newCardError: 'There was an error creating the card for the story'
    }
  }
}

export default messages
